module.exports = __webpack_public_path__ + "img/razuchim.a7a8a8b2.png";